import {
	CargoHandlingCondition,
	BodyPosture,
	PostureTwist,
	PostureLoadCenter,
	PostureArms,
	PostureHands,
	WorkOrganization
} from '../enums';

export const CARGO_HANDLING_LABELS: Record<CargoHandlingCondition, string> = {
	[CargoHandlingCondition.LOAD_HANDLED_WITH_BOTH_HANDS]: 'Load handled with both hands symmetrically',
	[CargoHandlingCondition.LOAD_HANDLED_WITH_TEMPORARILY_ONE_HAND]:
		'Load handled temporarily with one hand or asymmetrically with unequal weight distribution',
	[CargoHandlingCondition.LOAD_HANDLED_WITH_ONE_HAND]:
		'Load handled predominantly with one hand or has unstable center of balance'
};

export const BODY_POSTURE_LABELS: Record<BodyPosture, string> = {
	[BodyPosture.OPTION_1]: 'Hold/Hold',
	[BodyPosture.OPTION_2]: 'Hold/Grip variants',
	[BodyPosture.OPTION_3]: 'Grip variants/Grip variants',
	[BodyPosture.OPTION_4]: 'Hold/Lowering',
	[BodyPosture.OPTION_5]: 'Hold/Kneeling',
	[BodyPosture.OPTION_6]: 'Grip variants/Lowering',
	[BodyPosture.OPTION_7]: 'Grip variants/Kneeling',
	[BodyPosture.OPTION_8]: 'Lowering/Lowering',
	[BodyPosture.OPTION_9]: 'Lowering/Kneeling',
	[BodyPosture.OPTION_10]: 'Kneeling/Kneeling'
};

export const POSTURE_TWIST_LABELS: Record<PostureTwist, string> = {
	[PostureTwist.TWIST_OCCASIONAL_TRUNK]: 'Occasional identifiable trunk twisting and/or lateral bending',
	[PostureTwist.TWIST_FREQUENT_TRUNK]: 'Frequent or constant identifiable trunk twisting and/or lateral bending'
};

export const POSTURE_LOAD_CENTER_LABELS: Record<PostureLoadCenter, string> = {
	[PostureLoadCenter.LOAD_CENTER_OCCASIONAL]: 'Load center and/or hands occasionally away from the body',
	[PostureLoadCenter.LOAD_CENTER_FREQUENT]: 'Load center and/or hands frequently or constantly away from the body'
};

export const POSTURE_ARMS_LABELS: Record<PostureArms, string> = {
	[PostureArms.ARMS_OCCASIONAL]: 'Arms occasionally elevated, with hands between elbow and shoulder level',
	[PostureArms.ARMS_FREQUENT]: 'Arms frequently or constantly elevated, with hands between elbow and shoulder level'
};

export const POSTURE_HANDS_LABELS: Record<PostureHands, string> = {
	[PostureHands.HANDS_OCCASIONAL]: 'Hands occasionally above shoulder height',
	[PostureHands.HANDS_FREQUENT]: 'Hands frequently or constantly above shoulder height'
};

export const WORK_ORGANIZATION_LABELS: Record<WorkOrganization, { titleKey: string; descriptionKey: string }> = {
	[WorkOrganization.GOOD]: {
		titleKey: 'Good',
		descriptionKey:
			'Frequent variation of the physical load situation due to other activities (including other types of physical load) / without a rigid sequence of heavy physical loads within a single type of physical load during a single working day'
	},
	[WorkOrganization.RESTRICTED]: {
		titleKey: 'Restricted',
		descriptionKey:
			'Rare variation of the physical load situation due to other activities (including other types of physical load) / occasional sequence of heavy physical loads within a single type of physical load during a single working day'
	},
	[WorkOrganization.DESFAVORED]: {
		titleKey: 'Unfavorable',
		descriptionKey:
			'No or almost no variation of the physical load situation due to other activities (including other types of physical load) / frequent sequence of heavy physical loads within a single type of physical load during a single working day, with simultaneous load peaks'
	}
};
